module.exports = __webpack_public_path__ + "static/img/p2_4.60ea635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p2_4.png
// module id = dyjs
// module chunks = 1